/* global jQuery, serviceGeolocation, Map, debounce */

/**
 *
 * @param {Array} titles
 *
 * @return {String}
 */
function parseHeadlineFromTitles(titles) {

  var title = titles.join(', ');

  var lastCommaPos = title.lastIndexOf(',');

  if(lastCommaPos >= 0) {
    title = title.slice(0, lastCommaPos) + ' and' + title.slice(lastCommaPos + 1);
  }

  return title;


}


(function($) {

  /**
   * Default location (Indian Point)
   * @type {{lat: number, lng: number}}
   */
  var defaultLocation = {lat: 41.269722, lng: -73.952222};

  var currentLocation = defaultLocation;

  /**
   * Reactor Headline Element
   * @type {Element}
   */
  var reactorHeadline = document.querySelector('.reactor-headline');

  /**
   * Map Container Element
   * @type {String}
   */
  var mapContainerId = 'map-container';

  if (document.getElementById(mapContainerId)) {

    Map.init({
      secret: window.mapConfig.mapBoxSecret,
      mapElementId: mapContainerId,
      mapId: window.mapConfig.mapId,
      themeUrl: window.mapConfig.themeUrl,
      reactors: $.parseJSON(window.mapConfig.reactors)
    });

    Map.createHeaderMap(defaultLocation, {
      zoomControl: false,
      attributionControl: false
    });

    /**
     * Get User's location
     */
    serviceGeolocation.getLocation().then(function(location) {

      Map.currentUserLocation = location;

      /** Filter nearby Reactors by 75 miles **/
      Map.reactors.features = Map.filterNearbyReactors(75, true, 3);

      /** Add Reactors with labels **/
      Map.addReactors(true);

      Map.map.fire('resize');

      var titles = Map.getReactorTitles();

      var revisedHeadline = parseHeadlineFromTitles(titles);

      if(revisedHeadline) {
        reactorHeadline.innerHTML = 'You live near ' + revisedHeadline;
      }

    }).catch(function(error) {
      window.console.log(error.message);
    });
  }
}(jQuery));


